import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const BaliPage = () => {
  return <DestinationTemplate destinationId="bali" />;
};

export default BaliPage;
